export const KIND_LABELS = {
  revision: 'Revízna správa',
  manual: 'Ručne zadaná',
  'form-service-report': 'Servisná správa',
  'form-service-report-supplier': 'Servisná správa - Poskytovateľ č.2',
} as const;

export const KIND_OPTIONS = [
  { value: 'revision', label: KIND_LABELS.revision },
  { value: 'manual', label: KIND_LABELS.manual },
  { value: 'form-service-report', label: KIND_LABELS['form-service-report'] },
  { value: 'form-service-report-supplier', label: KIND_LABELS['form-service-report-supplier'] },
] as const;

export const KIND_OPTIONS_WITHOUT_MANUAL = KIND_OPTIONS.filter((option) => option.value !== 'manual');

export const KIND_BADGE_COLORS = {
  revision: 'indigo',
  manual: 'orange',
  'form-service-report': 'teal',
  'form-service-report-supplier': 'cyan',
} as const;

const KIND_ORDER = KIND_OPTIONS.reduce<Record<string, number>>((acc, { value }, index) => {
  acc[value] = index;
  return acc;
}, {});

/**
 * Returns the pretty label for the given kind.
 */
export function getKindPretty(kind?: string) {
  return KIND_LABELS[kind as keyof typeof KIND_LABELS] ?? kind ?? '';
}

/**
 * Returns the badge color for the given kind.
 */
export function getKindBadgeColor(kind?: string) {
  return KIND_BADGE_COLORS[kind as keyof typeof KIND_BADGE_COLORS] ?? 'gray';
}

/**
 * Returns kinds sorted in a stable display order.
 */
export function sortKinds(kinds: string[] = []) {
  return [...kinds].sort((left, right) => {
    const leftOrder = KIND_ORDER[left] ?? Number.MAX_SAFE_INTEGER;
    const rightOrder = KIND_ORDER[right] ?? Number.MAX_SAFE_INTEGER;

    if (leftOrder !== rightOrder) {
      return leftOrder - rightOrder;
    }

    return getKindPretty(left).localeCompare(getKindPretty(right));
  });
}

/**
 * Returns a human-readable representation of multiple kinds.
 */
export function getKindsPretty(kinds: string[] = []) {
  if (kinds.length === 0) {
    return 'Bez typu';
  }

  return sortKinds(kinds)
    .map((kind) => getKindPretty(kind))
    .join(', ');
}
